module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('p', {
    staticClass: "chapter-title-only",
    attrs: {
      "id": "_idParaDest-1",
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "bold CharOverride-7"
  }, [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('a', {
    attrs: {
      "href": "#/ProjectKeepsake61#_idParaDest-2"
    }
  }, [_c('i', [_vm._v("Introduction")])])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('a', {
    attrs: {
      "href": "#/ProjectKeepsake62#_idParaDest-4"
    }
  }, [_vm._v("Herman’s Brown Buckeyes by Amber Lanier Nagle")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('a', {
    attrs: {
      "href": "#/ProjectKeepsake63#_idParaDest-6"
    }
  }, [_vm._v("Uncle James’ Pocket Knife by Renea Winchester")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('a', {
    attrs: {
      "href": "#/ProjectKeepsake64#_idParaDest-8"
    }
  }, [_vm._v("My Beloved Mixing Bowl: “Big Green” by Marcia M. Swearingen")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('a', {
    attrs: {
      "href": "#/ProjectKeepsake65#_idParaDest-10"
    }
  }, [_vm._v("Birdie B.’s Silver Scissors by Sharon Huey")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake66#_idParaDest-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Father’s Fountain Pen by Estelle Rodis-Brown")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake67#_idParaDest-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Pregnancy Shirt by Coleen Brooks")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake68#_idParaDest-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Eastman Chemical Tank Car by Paul Garrison")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake69#_idParaDest-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Custard Spoon by Jean Lowrey")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake70#_idParaDest-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Harry Aft’s Signet Ring by David Aft")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake71#_idParaDest-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Brick by Wayne Minshew")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake72#_idParaDest-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Tale of Two Clocks by Martha Ford Fry")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake73#_idParaDest-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grandma Lissie’s Devil’s Ear by Sherry Poff")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake74#_idParaDest-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Book by Dorothy McCrory")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake75#_idParaDest-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blue Plate Special by Jane Starner")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake76#_idParaDest-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Carnival Glass by Nancy Ratcliffe")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake77#_idParaDest-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Picture Hat by Janie Dempsey Watts")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake78#_idParaDest-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jonathan’s Bible and Margaret’s Wax Vine by Jim Gilreath")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake79#_idParaDest-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Undefeated: The Cast by Peggy Gilbert")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake80#_idParaDest-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Nanny’s Magic Pan by Mitzi Boyd")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake81#_idParaDest-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lucky Lottery Numbers by Audrey Lanier Andersen")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake82#_idParaDest-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Beanie Babies by Rachel Brown")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake83#_idParaDest-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grandpa’s Pocket Watch by Dick Aft")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake84#_idParaDest-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grandma and Grandpa: Custody of the Figurines by Phyllis Qualls Freeman")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake85#_idParaDest-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Downed Bird by Joanne Crockett Lewis")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake86#_idParaDest-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Grandma’s Ugly Quilts by Barbara Tucker")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake87#_idParaDest-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Mother’s Guitar by Bob Wright")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake88#_idParaDest-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Stash of Shiny Silver Dollars by Dana Cooley-Keith")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake89#_idParaDest-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pink Angel by Lois Baldwin Good")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake90#_idParaDest-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Pie Plate by Karen H. Phillips")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake91#_idParaDest-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Music Box by Mariah Fulton")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake92#_idParaDest-64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Quill by Chris Foster")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake93#_idParaDest-66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Old Singer Sewing Machine by Amber Lanier Nagle")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake94#_idParaDest-68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Grandmother’s Pill Box Hat by Pauline Melton")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake95#_idParaDest-70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mama’s Gold Bangle Bracelet by Priscilla N. Shartle")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake96#_idParaDest-72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cousin Geraldine’s Watch by Judy Peterson")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake97#_idParaDest-74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tom Senior’s Wallet and Cell Phone by Tom Durkan")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake98#_idParaDest-76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Aunt Doris’ Red Cross Pin by Mary Lu Aft")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake99#_idParaDest-78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Blessing Around My Finger by Cynthia Wilson")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake100#_idParaDest-80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dad’s Dresser by Julie Moss")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake101#_idParaDest-82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Granny Rosie’s Organ and Milking Stool by Jesse Vaughn")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake102#_idParaDest-84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pieces of Esnoms-Au-Val by Francine Fuqua")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake103#_idParaDest-86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("My Tin Sewing Kit by Victoria R. Choate")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake104#_idParaDest-88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Grandma’s Bands of Gold by Christine Alexander Jennison")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake105#_idParaDest-90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Farm Table by Marvin Lewis")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake106#_idParaDest-92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Old Crank Telephone by Phyllis Qualls Freeman")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake107#_idParaDest-94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mattie Bell’s Bible by Missionary Janie Aker")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake108#_idParaDest-96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mementos of a Freemason by Ken Berry")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake109#_idParaDest-98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Old Iron Bed by Martha Buttrum")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake110#_idParaDest-100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Circus Teddy Bear by Elizabeth Swafford")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake111#_idParaDest-102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rubber Stamp by Tim Egenes")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake112#_idParaDest-104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Blue Diary by Shannon Lucadano")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake113#_idParaDest-106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jemaris’ Purple Cup by Carmen Slaughter")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake114#_idParaDest-108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Linde Star Necklace by Thelma J. Benner")])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake115#_idParaDest-110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Castanets by Debbie Dickson")])]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake116#_idParaDest-111",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Writing About Keepsakes")])])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake117#_idParaDest-112",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("With Sincere Gratitude")])])]), _vm._v(" "), _c('p', {
    staticClass: "text-hanging-indent"
  }, [_c('span', {
    attrs: {
      "href": "#/ProjectKeepsake118#_idParaDest-113",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Editor")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a1cc1fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectKeepsake60.vue
// module id = 66
// module chunks = 0